import request from '@/utils/api/request';

export const state = () => ({
  sidebarProjectsList: [],
  incomingTenders: [],
});

export const mutations = {
  setSidebarProjectsList(state, list) {
    state.sidebarProjectsList = list;
  },
  setIncomingTenders(state, list) {
    state.incomingTenders = list;
  },
};

export const actions = {
  async loadSidebarProjectsList({ commit }) {
    try {
      const { data } = await request.get('projects/', {
        params: {
          sort: '-updated_at',
        },
      });
      commit('setSidebarProjectsList', data.results);
    } catch (e) {
      console.error(e);
    }
  },
  async loadIncomingTenders({ commit }) {
    try {
      const { data } = await request.get('/incoming_tenders/offers/', {
        params: {
          sort: '-updated_at',
        },
      });
      commit('setIncomingTenders', data.results);
    } catch (e) {
      console.error(e);
    }
  },
};

export default { namespaced: true, state, mutations, actions };
